import React from 'react';
import {
  FormControlLabel, FormHelperText, Radio, RadioGroup,
} from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import * as yup from 'yup';
import { RadioControl } from '../FormControls';

export const petszelPartnerSchema = {
  petszelPartner: yup.string()
    .oneOf(['yes', 'no', 'unknown'], 'Petszel partner selection is required')
    .required('Petszel partner selection is required'),
};

function PetszelPartnerPartial(
  { control, errors }:
    {
      control: Control<any, any>,
      errors: FieldErrors<{ petszelPartner: string | null }>
    },
) {
  return (
    <RadioControl
      fieldName="petszelPartner"
      control={control}
      render={({ onChange, ...props }) => (
        <>
          {errors.petszelPartner && (
          <FormHelperText
            style={{ marginLeft: 0, marginRight: 0 }}
            error
          >
            {errors.petszelPartner?.message}
          </FormHelperText>
            )}
          <RadioGroup
            {...props}
            onChange={(event, value) => onChange({ target: { name: 'petszelPartner', value } })}
            aria-labelledby="petszel-partner-radio-group-label"
            row
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
            <FormControlLabel value="unknown" control={<Radio />} label="Unknown" />
          </RadioGroup>
        </>
        )}
    />
  );
}
export default PetszelPartnerPartial;
